import { Component, OnInit } from '@angular/core';
import { Meta, Title, DomSanitizer } from '@angular/platform-browser';
import { formatDate } from '@angular/common';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { APIService } from '../../services/api.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { SitemapComponent } from 'src/app/shared/sitemap/sitemap.component';

@Component({
  selector: 'app-job-search',
  templateUrl: './app-job-search.component.html',
  styleUrls: ['./app-job-search.component.scss'],
  standalone: false,
})
export class JobSearchComponent implements OnInit {
  eventData: any = [];
  canShare = false;

  constructor(
    public apiService: APIService,
    private router: Router,
    private title: Title,
    private meta: Meta,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private deviceDetectorService: DeviceDetectorService
  ) {}

  ngOnInit(): void {
    console.log('router', this.router.url);
    const slug = this.getSlug(this.router.url);
  }

  isMobile(): boolean {
    return this.deviceDetectorService.isMobile();
  }

  getSlug(url: string): string {
    const temp = url.split('?');
    const temp1 = temp[0].split('/');
    const lst = temp1.slice(-1)[0];
    return lst;
  }

  openDialog() {
    this.dialog.open(SitemapComponent, {
      width: this.isMobile() ? '90vw' : '800px',
      maxWidth: this.isMobile() ? '90vw' : '800px',
      height: this.isMobile() ? '90vh' : '600px',
      maxHeight: this.isMobile() ? '90vh' : '600px',
      restoreFocus: false,
      hasBackdrop: true,
      closeOnNavigation: true,
      disableClose: false,
    });
  }
}
